import { render, staticRenderFns } from "./OrderExpress.vue?vue&type=template&id=1adc35f4&scoped=true&"
import script from "./OrderExpress.vue?vue&type=script&lang=js&"
export * from "./OrderExpress.vue?vue&type=script&lang=js&"
import style0 from "./OrderExpress.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OrderExpress.vue?vue&type=style&index=1&id=1adc35f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adc35f4",
  null
  
)

export default component.exports